(function () {
    'use strict';

    angular
        .module('procedureModule')
        .directive('prcInlineRef', directive);

    directive.$inject = [];

    function directive() {
        return {
            // Using child scope gives access to the Section Block's scope
            scope: true,
            restrict: 'A',
            replace: false,
            templateUrl: function (elem, attrs) {
                if (attrs.entityType && attrs.entityType === 'Section') {
                    elem.removeAttr('title').removeAttr('style');
                    return '/app/shared/procedure/prcInlineRef.' + attrs.entityType + '.tpl.html';
                }

                if (attrs.entityType && attrs.entityType === 'Procedure') {
                    elem.removeAttr('title').removeAttr('style');

                    return '/app/shared/procedure/prcInlineRef.' + attrs.entityType + '.tpl.html';
                }

                if (attrs.entityType &&
                    (attrs.entityType === 'Responsibility')) {

                    elem.removeAttr('title');
                    elem.removeAttr('style');
                }
                
                if (attrs.entityType &&
                    (attrs.entityType === 'BusinessUnit'
                    || attrs.entityType === 'Committee'
                    || attrs.entityType === 'CorporateRole'
                    || attrs.entityType === 'GlossaryTerm'
                    || attrs.entityType === 'IAMSystem')) {

                    elem.removeAttr('title');
                    return '/app/shared/procedure/prcInlineRef.' + attrs.entityType + '.tpl.html';
                }

                return '/app/shared/procedure/prcInlineRef.default.tpl.html';
            },
            controller: ['$scope', '$location', '$anchorScroll', '$timeout',
                function ($scope, $location, $anchorScroll, $timeout) {

                    $scope.getUrl = function () {
                        if (_.isUndefined($scope.entity)) {
                            return;
                        }

                        var procedureType;
                        var code;

                        if ($scope.entity.ItemTypeCode === 'Procedure') {

                            procedureType = _.get($scope.entity, 'MetadataBlock.ProcedureType.Value');
                            code = _.get($scope.entity, 'MetadataBlock.ProcedureCode.Code');

                            if (_.isUndefined(code)) {
                                return;
                            }

                            return '/Procedure/' + procedureType + '/' + code + '/Published';

                        } else if ($scope.entity.ItemTypeCode === 'SectionBlock') {

                            var parentCode = _.get($scope.$parent, 'sectionBlock.ProcedureCode.Code');
                            procedureType = _.get($scope.entity, 'ProcedureType.Value');
                            code = _.get($scope.entity, 'ProcedureCode.Code');

                            if (_.isUndefined(parentCode) || _.isUndefined(code)) {
                                return;
                            }

                            var sectionAnchor = '#' + $scope.entity.Anchor;

                            // section is part of the same procedure
                            if (parentCode === code) {
                                return sectionAnchor;
                            }
                            // section is part of another procedure
                            else {
                                return '/Procedure/' + procedureType + '/' + code + '/Published' + sectionAnchor;
                            }
                        }
                    };

                    $scope.navigateTo = function ($event) {
                        if ($scope.entity) {

                            var path = $scope.getUrl();
                            
                            // do nothing if path is undefined
                            if (_.isUndefined(path)) {
                                $event.stopPropagation();
                                return;
                            }

                            $location.url(path);
                        }
                    };

                    /*
                        Manage references with tooltip inside another one.
                        We need to hide the parent one if a child is hovered, and resume displaying
                        the parent's when the child is not hovered anymore.
                     */
                    
                    var tmpHover = false;

                    $scope.onMouseEnter = function () {
                        tmpHover = true;
                        $scope.isHover = true;
                        $timeout(function () {
                            $scope.$emit('prcTooltipMouseEnter', {scopeId: $scope.$id});
                        });
                    };

                    $scope.onMouseLeave = function () {
                        tmpHover = false;
                        $scope.isHover = false;
                        $timeout(function () {
                            $scope.$emit('prcTooltipMouseLeave', {scopeId: $scope.$id});
                        });
                    };

                    $scope.$on('prcTooltipMouseEnter', function (event, arg) {
                        if (arg.scopeId !== $scope.$id) {
                            $scope.isHover = false;
                        }
                    });

                    $scope.$on('prcTooltipMouseLeave', function (event, arg) {
                        if (arg.scopeId !== $scope.$id) {
                            $scope.isHover = tmpHover;
                        }
                    });
                }],
            link: function (scope, elem, attrs) {
                attrs.visibleText = decodeURI(attrs.visibleText);
                scope.visibleText = attrs.visibleText;
                scope.entity = _.get(scope, attrs.entity);
            }
        };
    }
})();
